import AppLayout from "./AppTemplate";

export default AppLayout;
